import * as React from "react";

interface Props {
  text: string;
  customIconImage?: string;
}

export const EmptyView: React.FC<Props> = ({ text, customIconImage }) => {
  return (
    <div className={"flex flex-col items-center gap-5 mb-8 " + (customIconImage ? "mt-4" : "mt-8")}>
      {customIconImage && <img src={customIconImage} className="w-38 h-auto" />}
      <div className="text-center font-bold text-lg text-foreground">{text}</div>
    </div>
  );
};
